import { AxiosResponse } from "axios";
import { useApiRequest } from "../helper/api";
import {
  createupdateDeportmentModel,
  createupdateRoleModel,
  createupdateUserModel,
  DepartmentResponse,
  getRoleModel,
  userListModel,
} from "../model/adminModel";
import { toast } from "react-toastify";

const useAdminApi = () => {
  const { fetchData } = useApiRequest();

  const fetchGetUser = async (search: string): Promise<userListModel[] | null> => {
    const response = await fetchData(`user/searchuser`, {
      method: "POST",
      data: { skip: 0, search: search, limit: 30 },
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchGetUserByID = async (userID: number): Promise<userListModel | null> => {
    const response = await fetchData(`user/${userID}`, {
      method: "GET",
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchCreateUser = async (payload: createupdateUserModel): Promise<AxiosResponse | null> => {
    const response = await fetchData(`user/`, {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchUpdateUserByID = async (
    userID: number,
    payload: createupdateUserModel,
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(`user/${userID}`, {
      method: "PUT",
      data: payload,
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchDeleteUserByID = async (userID: number): Promise<AxiosResponse | null> => {
    const response = await fetchData(`user/${userID}`, {
      method: "DELETE",
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  // role

  const fetchGetRole = async (skip: number, limit: number): Promise<getRoleModel[] | null> => {
    const response = await fetchData(`roles/?skip=${skip}&limit=${limit}`, {
      method: "GET",
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchGetRoleByID = async (roleID: number): Promise<getRoleModel | null> => {
    const response = await fetchData(`roles/${roleID}`, {
      method: "GET",
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchCreateRole = async (payload: createupdateRoleModel): Promise<AxiosResponse | null> => {
    const response = await fetchData(`roles/`, {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchUpdateRoleByID = async (
    roleID: number,
    payload: createupdateRoleModel,
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(`roles/${roleID}`, {
      method: "PUT",
      data: payload,
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchDeleteRoleByID = async (roleID: number): Promise<AxiosResponse | null> => {
    const response = await fetchData(`roles/${roleID}`, {
      method: "DELETE",
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  // department

  const fetchGetDepartment = async (skip: number, limit: number): Promise<DepartmentResponse[] | null> => {
    const response = await fetchData(`department/?skip=${skip}&limit=${limit}`, {
      method: "GET",
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchGetDepartmentByID = async (departmentID: number): Promise<DepartmentResponse | null> => {
    const response = await fetchData(`department/${departmentID}`, {
      method: "GET",
    });
    if (response?.status) {
      // console.log("responsd", response);
      return response.data;
    }
    return null;
  };

  const fetchCreateDepartment = async (
    payload: createupdateDeportmentModel,
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(`department/`, {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      // console.log("responsd", response);
      toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchUpdateDepartmentByID = async (
    departmentID: number,
    payload: createupdateDeportmentModel,
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(`department/${departmentID}`, {
      method: "PUT",
      data: payload,
    });
    if (response?.status) {
     toast.success(response.data);
      return response.data;
    }
    return null;
  };

  const fetchDeleteDepartmentByID = async (departmentID: number): Promise<AxiosResponse | null> => {
    const response = await fetchData(`department/${departmentID}`, {
      method: "DELETE",
    });
    if (response?.status) {
      toast.success(response.data);

      return response.data;
    }
    return null;
  };

  return {
    fetchGetUser,
    fetchGetUserByID,
    fetchCreateUser,
    fetchUpdateUserByID,
    fetchDeleteUserByID,
    fetchGetRole,
    fetchGetRoleByID,
    fetchCreateRole,
    fetchUpdateRoleByID,
    fetchDeleteRoleByID,
    fetchGetDepartment,
    fetchGetDepartmentByID,
    fetchCreateDepartment,
    fetchUpdateDepartmentByID,
    fetchDeleteDepartmentByID,
  };
};

export default useAdminApi;
